import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/digitexpo-transparent.png'


const _withScopeId = n => (_pushScopeId("data-v-2e3ae2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "card-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "digit expo logo",
    class: "logo"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Scotland’s Biggest IT & Digital Event")
], -1))
const _hoisted_3 = { class: "data" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "DIGITExpo 2021", -1))
const _hoisted_6 = { class: "flex ion-align-items-center ion-margin-start" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "November 23, 2021", -1))
const _hoisted_8 = { class: "flex ion-align-items-center ion-margin-start" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "EICC, Edinburgh", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("CONTACT US")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "ion-text-justify" }, " The expo is the largest annual enterprise technology event run in Scotland, and a must-attend for senior technologists, digital innovators and IT leaders. "),
  /*#__PURE__*/_createElementVNode("h3", { class: "digit" }, "DIGIT"),
  /*#__PURE__*/_createElementVNode("p", { class: "ion-text-justify" }, " DIGIT is Scotland’s leading technology media & events company, dedicated to providing tech news, views, opinion for IT & Digital users & consumers. We have developed partnerships spanning industry, academia, government, membership groups, regulatory bodies and innovation centres. This ensures that our news and events are not restricted by the interests of a single perspective but instead reflect a balanced consensus, covering the core issues that are most relevant to the audience. Founded in October 2013, DIGIT.FYI and its network of events now reach nearly 30,000 business & technology users per week. DIGIT hosts major conferences and events in Scotland, including Digital Energy, Scot-Secure, Intelligent Automation, FinTech, DIGIT Leader, Digital Transformation, Data Protection Summit and Digit Expo, all serving as community platforms for business user collaboration and networking. "),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "PARKING"),
  /*#__PURE__*/_createElementVNode("p", { class: "ion-text-justify" }, " There are many car parks in close walking distance to the EICC. Please access the following links for further details: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "National Car Parks (NCP) in central Edinburgh"),
    /*#__PURE__*/_createElementVNode("li", null, " Sheraton Hotel Car Park located 150 meters from the EICC, with limited accessible parking spaces "),
    /*#__PURE__*/_createElementVNode("li", null, "Semple Street Car Park located 300 meters from the EICC")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "ARRIVAL"),
  /*#__PURE__*/_createElementVNode("p", { class: "ion-text-justify" }, " On the day, please enter via the Lennox Entrance and don’t forget to print your badge in advance to avoid queues. "),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "WIFI"),
  /*#__PURE__*/_createElementVNode("p", null, "Username: DIGITExpo21"),
  /*#__PURE__*/_createElementVNode("p", null, "Password: Digitexpo"),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "DRINKS RECEPTION"),
  /*#__PURE__*/_createElementVNode("p", { class: "ion-text-justify" }, " Between 15.45 and 17.00 a number of our exhibitors will have drinks at their stands. Look out for the exhibitors with balloons on their stands for an opportunity to network over a drink. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderMain, {
        "page-title": "About us",
        "default-href": "/home",
        "icon-about": true
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.calendarClear,
                    color: "primary"
                  }, null, 8, ["icon"]),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.location,
                    color: "primary"
                  }, null, 8, ["icon"]),
                  _hoisted_9
                ]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openExternalUrl('https://digit-expo.com/contact/')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}